import { HttpResult } from "widgets-for-react";
import { GroupPageResponse } from "../../sharepointPageApi/types/pageData";

export const childCourseGroupsBlockApi = async (id: number): Promise<HttpResult<GroupPageResponse>> => {
    const res = await fetch(`/api/v1/pages/child-course-groups/${id}`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: GroupPageResponse = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data,
    };
  }
